import React from 'react';
import { useOrderBump } from '../OrderBumpContext';
import { trackInitiateCheckout } from '../../utils/hotmartTracking';
const URL_WITH_PACKAGING = 'https://pay.hotmart.com/M104730533B?off=5yzcnkdd&checkoutMode=10';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  isPayment?: boolean;
}
export function CTAButton({
  children,
  href = '#offer',
  className = '',
  fullWidth = false,
  isPayment = true
}: CTAButtonProps) {
  const {
    isOrderBumpChecked,
    setShowPopup
  } = useOrderBump();
  const handleClick = (e: React.MouseEvent) => {
    if (isPayment) {
      e.preventDefault();
      if (isOrderBumpChecked) {
        trackInitiateCheckout();
        window.open(URL_WITH_PACKAGING, '_blank');
      } else {
        setShowPopup(true);
      }
    }
  };
  return <a href={isPayment ? '#' : href} onClick={handleClick} className={`
        inline-flex items-center justify-center
        bg-red-600 hover:bg-red-700
        text-white font-bold text-lg md:text-xl
        py-4 px-8 rounded-xl 
        shadow-[0_8px_20px_rgba(220,38,38,0.35)] hover:shadow-[0_12px_25px_rgba(220,38,38,0.5)]
        transition-all duration-300 transform hover:-translate-y-1
        cursor-pointer
        animate-[cta-pulse_2s_ease-in-out_infinite]
        uppercase
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-395">
      {children}
    </a>;
}